import { ButtonProps, Button as MuiButton } from '@mui/material'
import { PropsWithChildren } from 'react'

export const Button: React.FC<PropsWithChildren<ButtonProps>> = ({ children, ...props }) => {
  return <MuiButton variant='contained' {...props}>{children}</MuiButton>
}
